import { GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { ThemeConfig } from "@/plugins/config";

type RootGetterTree = GetterTree<RootState, RootState>;

export const getters: RootGetterTree = {
  theme(state: RootState): ThemeConfig {
    return state.theme;
  },

  isOnline(state: RootState): boolean {
    return state.isOnline;
  },
};
